<template>
  <div class="section">
    <h3 class="mt-4">
      {{ value }}
      <small class="text-muted">
        <font-awesome-icon icon="edit" @click="openModal()" />
      </small>
    </h3>
    <b-modal :id="uid('modal')"
             centered size="xl"
             title="タイトル"
             @shown="modalShown"
             @ok="modalSave">
      <form @submit.stop.prevent="modalSubmit">
        <div class="form-group">
          <input type="text"
                 :id="uid('modal-text')"
                 class="form-control"
                 ref="modalText"
                 rows="30"
                 v-model="text">
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'StoryView',

  data(){
    return {
      text: ''
    }
  },

  methods: {
    emitter(value){
      this.$emit('input', value)
    },

    uid(prefix){
      return prefix + '-' + this._uid
    },

    openModal(){
      this.text = this.value
      this.$bvModal.show(this.uid('modal'))
    },

    modalShown(){
      this.$refs.modalText.focus()
    },

    modalSubmit(){
      this.modalSave()
      this.$bvModal.hide(this.uid('modal'))
    },

    modalSave(){
      this.emitter(this.text)
    }
  },

  props: {
    value: {
      required: false,
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
</style>
